import React, { useState, useContext, useEffect } from 'react';

import './menu.css'
import apptheme from '../theme/default';

import { useNavigate } from "react-router-dom";
import LogoutIcon from '@mui/icons-material/Logout';
import { Box, Button } from '@mui/material';
import Logout from '../Settings/Logout'
import { useLocation } from 'react-router-dom'
import MenuIcon from '@mui/icons-material/Menu';
import { externalComponent } from '../AppRoutes';
import Submenu from './submenu-item';

import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import ContactEmergencyIcon from '@mui/icons-material/ContactEmergency';
import SettingsIcon from '@mui/icons-material/Settings';
import { getSession } from '../../contexts/auth';
import SsidChartIcon from '@mui/icons-material/SsidChart';
import EqualizerIcon from '@mui/icons-material/Equalizer';



const menus = () => {

  const user = getSession()
  const permissions = user?.permissions

  return ({
    eventos: { title: 'Eventos', icon: (<RemoveRedEyeIcon />), permissions: permissions.view_eventos },
    credenciados: { title: 'Credenciados', icon: (<ContactEmergencyIcon />), permissions: true },
    relatorios: { title: 'Relatórios', icon: (<SsidChartIcon />), permissions: true },
    graficos: { title: 'Gráficos', icon: (<EqualizerIcon />), permissions: false },
    configuracoes: { title: 'Configurações', icon: (<SettingsIcon />), permissions: true },
  })

}

const exit = () => ({
  exit: { title: 'Sair', icon: (<LogoutIcon />), overthrow: { onClick: Logout }, permissions: true }
})



const MenuComponent = () => {
  const { width, isMobile } = useContext(externalComponent)
  const [showMenu, setShowmenu] = useState(false)
  const locationURL = window.location.origin



  const selectedTheme = {
    sx: {
      color: apptheme.secondaryColor,
      backgroundColor: `${apptheme.tertiaryColor} !important`
    },
    className: 'main-menu-button selected'
  }

  const menuTheme = {
    sx: { color: apptheme.secondaryColor },
    className: 'main-menu-button'
  }

  const decideTheme = (actualRoute) => {
    if (actualRoute === route.pathname)
      return { ...selectedTheme }
    return { ...menuTheme }
  }

  const decideThemeSubmenu = (routeList) => {
    const selected = routeList.includes(route.pathname)
    if (selected)
      return { ...selectedTheme }
    return { ...menuTheme }
  }

  const route = useLocation()
  const navigate = useNavigate();

  useEffect(() => {
    if (!('backtobase' in window))
      window.backtobase = () => { }
  }, [])


  return (
    <Box className={`${(isMobile || showMenu) ? 'overlay' : ''}`} sx={{ height: (!isMobile || showMenu) ? '100%' : 'max-content' }}>
      {(!isMobile || showMenu) ?
        <Box className='lateral-menu' sx={{ backgroundColor: apptheme.primaryColor, height: "100%" }}>
          <Box className='inside-menu'>
            <Button
              children={<img src={`${process.env.PUBLIC_URL}/catraca.png`} alt="CatracaIcon" className='catraca-icon' />}
            >
            </Button>
            {Object.entries(menus()).map(([key, value]) =>
              <>
                {value.permissions ?
                  <>
                    {!value.submenu ? <Button
                      {...decideTheme(`/${key}`)}
                      onClick={() => { window?.backtobase(); navigate(`/${key}`); setShowmenu(false) }}
                      children={<>{value.icon}<span>{value.title}</span></>}
                      {...value.overthrow}
                    >
                    </Button>
                      :
                      <Submenu config={value} theme={decideThemeSubmenu} />
                    }
                  </>
                  : null}
              </>
            )}

          </Box>
          <Box className='inside-menu'>
            {Object.entries(exit()).map(([key, value]) =>
              <>
                {value.permissions ?
                  <Button
                    {...decideTheme(`/${key}`)}
                    onClick={() => navigate(`/${key}`)}
                    children={<>{value.icon}<span>{value.title}</span></>}
                    {...value.overthrow}
                  >
                  </Button> : null}
              </>
            )}
          </Box>
        </Box>
        :
        <Box className='inside-menu'>
          <Button
            sx={{
              color: apptheme.tertiaryColor,
            }}
            onClick={() => { setShowmenu(true) }}
            children={<MenuIcon />}
            className='main-menu-button hamburguer'
          >
          </Button>
        </Box>
      }
      {showMenu && <Box onClick={() => setShowmenu(false)} className='backdrop'></Box>}
    </Box>
  )
};

export default MenuComponent;